export default __webpack_public_path__ + "b612449a1eeb3f9faeeb9a7afabffdaf.png";